module.exports = __webpack_public_path__ + "static/img/master_studio_manage_2.51b2163.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/master_studio_manage_2.png
// module id = xwe2
// module chunks = 11